import Service from '@/services/modules/type_of_payments.service';

const add = async({ commit }, _object) => {
    const response = Service.add(_object);

    response.then(function (_response) {
        commit('add', _response);
    });

    return response;
};

const all = async ({ commit }) => {
    const response = Service.get();

    response.then(function (_response) {
        commit('setList', _response);
    });

    return response;
};

const edit = async({ commit }, _module) => {
    const response = Service.edit(_module.id, _module);

    return response;
};

const get = async ({ commit }, _id) => {
    const response = Service.get(_id);

    response.then(function (_response) {
        commit('setObject', _response);
    });

    return response;
};


const rem = async({ commit }, _module) => {
    const response = Service.rem(_module.id);

    return response;
};

export default {
    add,
    all,
    edit,
    get,
    rem
};